// eslint-disable-next-line vue/prefer-import-from-vue
import { toRaw } from '@vue/reactivity'
import { Cache } from './main'

export class StoreCache extends Cache {
	piniaStore

	constructor(store, settings={}) {
		super('store-cache', settings, 'getter')
		this.piniaStore = store
	}

	async set(value, getter) {
		await super.set(toRaw(value), `${this.piniaStore}/${getter}`)
	}

	async get(getter) {
		const item = await super.get(`${this.piniaStore}/${getter}`)
		return item ? item.value : null
	}
}